export const formValidate = ({ validations, values }) => {
  let errors = {};
  // console.log({ values,validations });
  for (let i = 0; i < validations.length; i++) {
    const value = values.hasOwnProperty(validations[i].name)
      ? values[validations[i].name]
      : "";
    if (validations[i].type === "REQUIRED" && !value)
      errors[validations[i].name] = validations[i].message;

    if (
      validations[i].type === "REGEX" &&
      !validations[i].expression.test(value)
    )
      errors[validations[i].name] = validations[i].message;

    if (
      validations[i].type === "MATCH" &&
      value != values[validations[i].matchField]
    )
      errors[validations[i].name] = validations[i].message;
  }
  // console.log({ errors });
  return { status: Object.keys(errors).length, errors };
};
